export const getMenuData = [
  {
    category: true,
    title: 'Dashboard',
  },
  {
    title: 'Current auctions',
    key: 'auctionDashboard',
    icon: 'fe fe-home',
    url: '/dashboard',
    roles: ['admin', 'participant', 'operator'], // set user roles with access to this route
    count: 0,
  },
  {
    category: true,
    title: 'Auctions & Participants',
  },
  {
    title: 'Auctions',
    key: 'auctions',
    icon: 'fe fe-database',
    children: [
      {
        title: 'Auctions list',
        key: 'auctionsList',
        icon: 'fe fe-list',
        url: '/auctions',
        roles: ['admin', 'participant', 'operator'],
      },
      {
        title: 'New auction',
        key: 'newAuction',
        icon: 'fe fe-cast',
        url: '/auctions/create',
        roles: ['admin', 'operator'],
      },
    ],
  },
  {
    title: 'Users',
    key: 'users',
    icon: 'fe fe-user',
    roles: ['admin', 'operator'],
    children: [
      {
        title: 'Users list',
        icon: 'fe fe-users',
        key: 'usersList',
        url: '/users',
      },
      {
        title: 'New user',
        key: 'newUser',
        icon: 'fe fe-user-plus',
        url: '/users/new',
      },
    ],
  },
  {
    title: 'Participants',
    key: 'participants',
    icon: 'fe fe-briefcase',
    roles: ['admin', 'operator'],
    children: [
      {
        title: 'Participants list',
        icon: 'fe fe-list',
        key: 'participantsList',
        url: '/participants',
      },
      {
        title: 'New participant',
        key: 'newParticipant',
        icon: 'fe fe-plus-circle',
        url: '/participants/new',
      },
    ],
  },
  {
    title: 'Settings',
    key: 'settings',
    icon: 'fe fe-settings',
    roles: ['admin', 'operator'],
    children: [
      {
        title: 'Company settings',
        key: 'settings',
        url: '/settings/company',
      },
      {
        title: 'Provisioning',
        key: 'provisioning',
        url: '/settings/provisioning',
      },
      {
        title: 'Auction types',
        key: 'auctiontypes',
        url: '/settings/auctiontypes',
      },
      {
        title: 'API Keys',
        key: 'apikeys',
        icon: 'fe fe-key',
        url: '/settings/api-keys',
        roles: ['admin'],
      },
      {
        title: 'Admin users',
        key: 'admins',
        icon: 'fe fe-shield',
        url: '/settings/admins',
        roles: ['admin'],
      },
      {
        title: 'Excel Reports',
        key: 'reports',
        icon: 'fe fe-file-text',
        url: '/settings/reports',
      },
    ],
  },
  {
    title: 'Day-Ahead auctions',
    key: 'day-ahead',
    icon: 'fe fe-folder',
    roles: ['admin'],
    children: [
      {
        title: 'Results',
        key: 'day-ahead-results',
        url: '/day-ahead/results',
      },
      {
        title: 'EPEX Members',
        key: 'day-ahead-members',
        url: '/day-ahead/members',
      },
    ],
  },
  {
    title: 'My profile',
    url: '/profile',
    key: 'profile',
    icon: 'fe fe-user',
    roles: ['admin', 'operator', 'participant'],
  },
]
